import { logEvent } from "firebase/analytics";
import { log } from "../ui/log";
import { analytics } from "./firebaseInit";

export const trackEvent = (
  evtName: string,
  // biome-ignore lint/suspicious/noExplicitAny: Because
  eventParams?: { [key: string]: any } | undefined,
) => {
  const finalEventName = evtName.replaceAll("-", "_").replaceAll(" ", "_");
  if (__DEV__) {
    log.analytics(finalEventName);
    return;
  }

  return logEvent(analytics, finalEventName, eventParams);
};
